"use strict";
import configuration from './configuration.js';
/** Réception de l'événement dropdownItemSelected */
document.addEventListener('dropdownItemSelected', function (event) {
    const {text, value, dropdown} = event.detail;

    console.debug('Dropdown sélectionné:', {
        texte: text,
        valeur: value
    });

    // Exemple: Charger du contenu basé sur la sélection
    if (dropdown.id === 'typePrestationDropdown') {
        const previewSection = document.getElementById('preview-prestations');

        // Afficher la section preview
        if (previewSection) {
            // Vous pouvez charger du contenu dynamique ici
            // Par exemple avec fetch pour charger du contenu AJAX
            loadPrestationContent(value);
        }
    }
});

/**
 * Charge le contenu des prestations en fonction du type sélectionné
 * @param {string} type - Type de prestation (public, particulier, entreprise)
 */
function loadPrestationContent(type) {
    const previewSection = document.getElementById('preview-prestations');
    if (!previewSection) return;
    // rechargement de la page avec le typePrestation changer
    window.location.href = `${MAS.urlbase}?typePrestation=${type}`;
}


/**
 * fonction qui permet de faire les évenements lors du scroll de la page
 * @author: Thiney Jean-Baptiste <jb@innov-appli.com>
 */
function onScrollDocument(){
    let scrollTop = window.scrollY;
    if(scrollTop > configuration.gapScrollHeader){
        document.querySelector("header").classList.add("header-scroll");
        document.querySelector("#bandeau_header_right").classList.add("bandeau-header-right-scroll");
        document.querySelector("#bandeau_header_left").classList.add("bandeau-header-left-scroll");
    }else{
        document.querySelector("header").classList.remove("header-scroll");
        document.querySelector("#bandeau_header_right").classList.remove("bandeau-header-right-scroll");
        document.querySelector("#bandeau_header_left").classList.remove("bandeau-header-left-scroll");
    }
}

/**
 * fonction qui permet de faire les évenements lors du resize de la page
 * @author: Thiney Jean-Baptiste <jb@innov-appli.com>
 */
function onResizeDocument(){
    
}


export {onScrollDocument, onResizeDocument};